<template>
  <div class="logo-header">
    <img :src="arcaneLogo" alt="Arcane Logo" class="logo" />
    <BbBtn size="small" type="secondary" @click="handleClick">
      <BbIcon name="plus-small" size="small" />
      <TextBody i18n-key="common.new" />
    </BbBtn>
  </div>
</template>

<script>
import arcaneLogo from '~/assets/svg/Arcane-logo.svg';
import TextBody from '@/components/common/TextBody.vue';

export default {
  components: { TextBody },
  props: {
    handleClick: {
      type: Function,
      required: true,
    },
  },

  setup() {
    return {
      arcaneLogo,
    };
  },
};
</script>

<style lang="scss" scoped>
.logo-header {
  @include media-breakpoint-up('sm') {
    display: flex;
  }

  display: none;
  flex-direction: row;
  gap: 28px;
  justify-content: center;
  align-items: center;
  min-height: 64px;

  .logo {
    height: $bb-spacing-5;
    width: 101px;
  }
}
</style>
